import React, { Component, PropTypes } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import _ from 'lodash';

import { NitroHeading, NitroDivider, NitroDrawer } from 'nitro-components';

import CostcentreApi from '../../api/CostcentreApi';
import * as globalActions from "../../action/CommonActions";

import DisableCover from "../libs/disabled";

import FilterSection from './FilterSection';

import ChipInput from './filters/chip-input/ChipInput';
import { NitroLoading } from 'nitro-components/build/nitro';

class FilterDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterTouched: false,
      filters: [...props.filters],
      fetchRestrictions: false,
    };
    this.setFilter = this.setFilter.bind(this);
  }

  componentWillReceiveProps(nextProp) {
    const nextPropFilters = nextProp.filters;
    const oldPropFilters = this.props.filters;
    this.setState({
      filters: [...nextPropFilters]
    });

    if(nextPropFilters[0].title.toLowerCase() === 'country' &&
      nextProp.open) {
      this.getCompanyDynamicFilters(nextPropFilters[0].value, nextPropFilters[1].value);
    }

    if(nextProp.open && !this.props.open) {
      this.setState({
        filterTouched: false,
      })
    }
  }

  setFilter = () => {
    const { extraSection } = this.props;
    const { setGlobalDynamicFilter } = this.props.globalActions;

    if (extraSection) {
      extraSection.action();
    }

    const outFilter = [];
    const dynFilter = [];
    this.state.filters.forEach((filter, idx) => {
      if (idx <= 1) {
        outFilter.push(filter);
      } else {
        if(filter.value.length > 0)
          dynFilter.push(filter);
      }
    })

    setGlobalDynamicFilter(dynFilter);
    this.props.action(outFilter, dynFilter);
  };

  cancelFilter = () => {
    this.setState({
      filters: this.props.filters,
    });
    this.props.close();
  };

  getCompanyDynamicFilters(countryCode, companyCode) {
    this.setState({
      fetchRestrictions: true
    });
    CostcentreApi.getCompanyRestrictionFilters(countryCode, companyCode).then(data => {

      const stateFilters = this.state.filters.slice(0, 2);
      const { filterTouched } = this.state;

      const dynaFilters = data.map((opt) => {

        let dynDuxFil;
        if(this.props.dynamicFilters)
          dynDuxFil = this.props.dynamicFilters.find((item) => item.typeId === opt.typeId);

        const newFilter = {
          filterType: 'dynamic',
          typeId: opt.typeId,
          title: opt.typeName,
          value: (dynDuxFil && !filterTouched )? [...dynDuxFil.value] : [],
          source: opt.options,
          component: ChipInput,
        }

        stateFilters.push(newFilter);
      })

      this.setState({
        fetchRestrictions: false,
        filters: stateFilters
      });
      this.forceUpdate();
    });
  }

  onChange = (index, filter) => {
    let filters = [...this.state.filters];
    const newFilter = Object.assign({}, filters[index], filter);
    filters[index] = newFilter;

    this.setState({
      filterTouched: true,
      filters: filters
    })

    if (index === 1) {
      this.getCompanyDynamicFilters(filters[0].value, filter.value)
    }

  };

  render() {
    const { open, title, close, sectionTitle, extraSection, validator, actions, action } = this.props;

    const { filters, fetchRestrictions } = this.state;

    const disabled = validator && !validator(filters);

    const { left } = actions || {};
    const footerActions = {
      left,
      right: [
        {
          action: close,
          label: 'Cancel'
        },
        {
          action: this.setFilter,
          label: 'Apply',
          variant: 'secondary',
          disabled
        }
      ]
    };

    return (
      <NitroDrawer
        isOpen={open}
        close={close}
        staticFooter
        actionDisabled={disabled}

        actions={footerActions}
        cancelAction={this.cancelFilter}>

        <NitroHeading size="1" variant="secondary" label={title} />

        {sectionTitle &&
          <section>

            <NitroHeading size="2" variant="secondary" label={sectionTitle} align="center" noMargin />
            <NitroDivider sidePanel variant="base3" />

          </section>}

        {filters.map((filter, index) => (
          <FilterSection filters={filters} action={this.onChange} key={index} index={index} />
        ))}

        {extraSection && <section>{extraSection.component}</section>}

        { fetchRestrictions &&
          <div>
            <DisableCover />
            <NitroLoading />
          </div>
        }

      </NitroDrawer>
    );
  }
}

FilterDrawer.propTypes = {
  action: PropTypes.func,
  actions: PropTypes.object,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  close: PropTypes.func.isRequired,
  filters: PropTypes.array,
  extraAction: PropTypes.object,
  extraSection: PropTypes.object,
  sectionTitle: PropTypes.string,
  validator: PropTypes.func,
  dynamicFilters: PropTypes.array,
};

FilterDrawer.defaultProps = {
  width: 460
};

const mapStateToProps = state => {
  const { dynamicFilters } = state.common;
  return {
    dynamicFilters,
  };
}

const mapDispatchToProps = dispatch => ({
  globalActions: bindActionCreators(globalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterDrawer);



// WEBPACK FOOTER //
// ./src/components/filter/FilterDrawer.js